export default [
	{
		key     : "new_incident",
		text    : "new_incident",
		action 	: "confirm_options",
		action_confirm  : "default",
		contact : "123",
		descriptions : [],
		options  : [
			{
				key : "name",
				text : "name_incident",
				default : "call to ...",
				type 	: "text",				
			},
			{
				key : "contact",
				text : "contact",				
				default : "123",
				type 	: "number",
			},
			{

				key : "description",
				text : "description",
				default : "Calling to ...",
				type 	: "textarea",				
			},

		],
	},
	{
		key     : "incidents", // create_
		text    : "Incidents", // Create 
		action 	: "incidents", // create_
		contact : "",
		descriptions : [],
		list  	 : [
			/*{
    			key     : "new_incident",
    			text    : "new_incident",
    			action 	: "confirm_options",
    			contact : "", 
				action_confirm  : "new_incident",
				options  : [
					{
						key : "name",
						text : "Incident",
						default : "",
						type 	: "text",
						placeholder : "name_incident",				
					},
					{
						key 	: "contact",
						text 	: "contact",
						default : "",						
						type 	: "number",

					},
					{
						key 		: "description",
						default 	: "",
						text 		: "description",
						placeholder : "Description incident", 
						type 		: "textarea",				
					},

				],
			},*/
		],


	},
/*	{
		key     : "download_pdf",
		text    : "download_pdf",
		action 	: "download_pdf",
		action_confirm  : "",
		contact : "",
	},*/
	// {
	// 	key     : "update_report",
	// 	text    : "Update report",
	// 	action 	: "update_report",
	// 	contact : "",
	// },
];